import { CollectionPolicy } from "../../../jsx/components/Dashboard/CollectionPolicy";

const HomeWrapper = () => {
  return <CollectionPolicy />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(HomeWrapper);
